import React from "react";

const ContactComponent = () => {
    return (
        <div className="section-img-text-horizontal" id="contact-section">
            <img src="/pics/LB.PNG.webp" alt="Lucas Brand" />
            <div className="section-img-text-horizontalText">
                <h3 className="boldText">Drop me a line!</h3>
                <div className="spacer-small"></div>
                <p className="boldText">Lucas Brand</p>
                <div className="horizontal-text">
                    <i className="bi bi-envelope"></i>
                    <a href="mailto: info@dockline.digital">info@dockline.digital</a>
                </div>
                <div className="horizontal-text">
                    <i className="bi bi-phone"></i>
                    <a href="tel: +49 152 53819840">+49 152 53819840</a>
                </div>
            </div>
        </div>
    );
};

export default ContactComponent;